<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">線上點餐管理 / {{ currentTitle }}</b-col>
      <b-col>
        <div class="text-right">
        </div>
      </b-col>
    </b-row>

      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
        <p class="tab" style="font-siz">
            <!-- 使用 router-link 组件来導航. -->
            <!-- 通過傳入 `to` 属性指定鏈接. -->
            <!-- <router-link> 默認會被渲染成一个 `<a>` 標籤 -->
            <router-link :to="{ name: 'store_list' }" v-if="permF27 >= 1"><span class="tab-link">分店MID設定</span></router-link>
            <span v-if="permF27 >= 1 && permF39 >= 1"> | </span>
            <router-link :to="{ name: 'store_payment_memo' }" v-if="permF39 >= 1"><span class="tab-link">支付方式備註</span></router-link>
        </p>
        <!-- 路由出口 -->
        <!-- 路由匹配到的组件將渲染在這裡 -->
          <router-view></router-view>
          </div>
        </div>
      </b-card>
    </div>
</template>

<script>
import { getFunctionPermission } from '@/js/LoginUserFunction.js'

export default {
  data () {
    return {
      permF27: 0,
      permF39: 0
    }
  },
  computed: {
    currentTitle () {
      return this.$route.name === 'store_payment_memo' ? '支付方式備註' : '分店MID設定'
    },
    // 代理 home.vue 的 Loading flag，避免子頁 (List.vue / PaymentMemo.vue) 設定 this.$parent.Loading
    // 時只更新到本層的 Index.vue，導致頂層 loading 遮罩失效
    Loading: {
      get () { return this.$parent && this.$parent.Loading },
      set (v) { if (this.$parent) this.$parent.Loading = v }
    }
  },
  methods: {
    // 代理 home.vue 的 logOut，讓子頁 this.$parent.logOut(...) 不會踩到 undefined
    logOut (...args) {
      if (this.$parent && typeof this.$parent.logOut === 'function') {
        this.$parent.logOut(...args)
      }
    },
    // 代理 home.vue 的 verificationErrMsg (相容既有 storeholiday-style 寫法 this.$parent.$parent.verificationErrMsg)
    verificationErrMsg (...args) {
      if (this.$parent && typeof this.$parent.verificationErrMsg === 'function') {
        this.$parent.verificationErrMsg(...args)
      }
    }
  },
  created () {
    this.permF27 = getFunctionPermission('F27')
    this.permF39 = getFunctionPermission('F39')

    // 兩個權限皆無：回登入後預設頁
    if (this.permF27 < 1 && this.permF39 < 1) {
      this.$router.push({ name: 'name' })
      return
    }

    // 若進入到 store_index 但子路由未指定，依權限導向預設子頁
    if (this.$route.name === 'store_index') {
      if (this.permF27 >= 1) {
        this.$router.replace({ name: 'store_list' })
      } else {
        this.$router.replace({ name: 'store_payment_memo' })
      }
      return
    }

    // 若進入了沒權限的子頁，重新導向有權限的那個
    if (this.$route.name === 'store_list' && this.permF27 < 1 && this.permF39 >= 1) {
      this.$router.replace({ name: 'store_payment_memo' })
    } else if (this.$route.name === 'store_payment_memo' && this.permF39 < 1 && this.permF27 >= 1) {
      this.$router.replace({ name: 'store_list' })
    }
  }
}
</script>

<style scoped>
.router-link-active .tab-link{
  color: red;
  /* background:pink; */
}
.tab-link{
  color: #004f2d;
  /* background:pink; */
}
.tab-link:hover{
  text-decoration: underline;
  color: #179a53 !important;
  /* background:pink; */
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/store/Index.vue